import Vue from 'vue';
import VueI18n from 'vue-i18n';

import { messages } from './dictionary';

Vue.use(VueI18n);

function loadLocaleMessages(text) {
  const locales = ['es', 'en','fr','de','it','pt','tr', 'jp', 'cn', 'sa'];
  const m = text;
  locales.forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      m[locale] = locales(key);
    }
  });
  return m;
}

export default new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: loadLocaleMessages(messages),
  silentFallbackWarn: true,
})
